"use client"

import type { FunctionComponent, KeyboardEventHandler, PropsWithChildren } from "react"

import classNames from "classnames"
import { useEffect, useRef, useState } from "react"

import { Button } from "@jobteaser/spark/components/Button"

import styles from "./ReadMore.module.css"

type ReadMoreProps = PropsWithChildren<{
  seeLessLabel: string
  seeMoreLabel: string
}>

export const ReadMore: FunctionComponent<ReadMoreProps> = ({ children, seeLessLabel, seeMoreLabel }) => {
  const [isTooLongText, setIsTooLongText] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)
  const clampedTextRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const clampedText = clampedTextRef?.current
    if (!clampedText) return

    const isTooLong = clampedText.scrollHeight > clampedText.clientHeight

    if (isTooLong) {
      setIsTooLongText(true)
    }
  }, [])

  const handleClick = (): void => {
    setIsExpanded(prevState => !prevState)
    if (isExpanded) {
      document.getElementById("description-summary-block")?.scrollIntoView({ behavior: "smooth" })
    }
  }

  const handleKeyDown: KeyboardEventHandler = (event): void => {
    if (event.nativeEvent.code === "Enter" || event.nativeEvent.code === "Space") {
      setIsExpanded(prevState => !prevState)
    }
  }

  const containerClassNames = classNames({
    [styles.main___clamped]: !isExpanded,
    [styles.main___isTooLongText]: isTooLongText,
  })

  return (
    <>
      <div ref={clampedTextRef} className={containerClassNames}>
        {children}
      </div>

      {isTooLongText && (
        <Button variant="secondary" className={styles.button} onKeyDown={handleKeyDown} onClick={handleClick}>
          {isExpanded ? seeLessLabel : seeMoreLabel}
        </Button>
      )}
    </>
  )
}
